export default __webpack_public_path__ + "static/media/walking.4e65cce3.jpeg";